var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.handle && _vm.tabela && _vm.carga
    ? _c("div", { staticClass: "portlet light" }, [
        _vm.tituloFormatado
          ? _c("div", { staticClass: "portlet-title" }, [
              _c("div", { staticClass: "caption" }, [
                _c("i", { staticClass: "fa fa-paste font-green" }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "caption-subject font-green bold uppercase" },
                  [_vm._v(_vm._s(_vm.tituloFormatado))]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "portlet-body" }, [
          _c("div", { staticClass: "clearfix" }, [
            _c(
              "div",
              {
                staticClass:
                  "form-actions top nobg no-border commands-bar fluid list-commands-bar",
                attrs: { id: "ctl00_Main_GRID_toolbar" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn green",
                    attrs: { type: "button", disabled: !this.podeInserir },
                    on: {
                      click: function ($event) {
                        return _vm.novoRegistro()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-plus" }),
                    _vm._v(" Novo\n                "),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "clearfix row clearfixborder-collapse": "separate",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "filter-search-form note note-info note-bordered",
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                      },
                      [
                        _c("div", { staticClass: "input-icon right" }, [
                          _vm.loading
                            ? _c("i", {
                                staticClass:
                                  "fa fa-spinner fa-pulse fa-3x fa-fw fa-spin font-dark",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.filtro,
                                expression: "filtro",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              type: "text",
                              id: "search-input",
                              autocomplete: "off",
                              disabled: _vm.filtroDisabled,
                              placeholder: "Pesquisa...",
                              title: "Filtre registros na tabela selecionada.",
                            },
                            domProps: { value: _vm.filtro },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.filtro = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix margin-top-10" }, [
            _c("div", {
              staticClass: "treeview",
              on: { keyup: _vm.keymonitor },
            }),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }